import { P2GGrid } from '@parcel2go/core-ui';
import { ItemPrice } from '~/components/basket-summary/basket/header/item-price';
import QuoteCardServiceLogo from '~/components/quote-results/card/quote-card-logo';
import { Currency } from '~/lib/types/basket-types';
import { ProductItem, ProductSlots } from '../adapters/product-types';
import { ProductSummaryHeaderContent } from './product-summary-header-content';

type ProductSummaryHeaderProps = {
  index: number;
  isXs?: boolean;
  item: ProductItem;
  currency: Currency;

  slots?: ProductSlots;
};

export default function ProductSummaryHeader({
  index,
  item,
  currency,
  slots,
  isXs = false
}: ProductSummaryHeaderProps) {
  return (
    <P2GGrid
      container
      dataTestId={`basket-item-header-${index}`}
      alignItems="center"
      spacing={2}
      sx={{ flexWrap: { sm: 'nowrap' } }}
    >
      {isXs ? (
        <>
          <P2GGrid item>
            <QuoteCardServiceLogo slug={item.service.slug} width={140} dataTestId="basket-item-header-service-logo" />
          </P2GGrid>
          {slots?.['product-summary-header-prefix']?.(index, item.id, item)}
          <P2GGrid item dataTestId={`basket-item-header-summary-${index}`} xs={12}>
            <ProductSummaryHeaderContent parcels={item.parcels} service={item.service} />
          </P2GGrid>
          <P2GGrid item xs={12}>
            <ItemPrice
              currency={currency}
              subTotal={item.price.subTotal}
              tax={item.price.total - item.price.subTotal}
            />
          </P2GGrid>
          {slots?.['product-summary-header-suffix']?.(index, item.id, item)}
        </>
      ) : (
        <>
          <P2GGrid item>
            <QuoteCardServiceLogo slug={item.service.slug} height={45} />
          </P2GGrid>
          <P2GGrid item dataTestId={`basket-item-header-summary-${index}`} md="auto" flexGrow={1}>
            <ProductSummaryHeaderContent parcels={item.parcels} service={item.service} />
          </P2GGrid>

          {slots?.['product-summary-header-prefix']?.(index, item.id, item)}

          <P2GGrid item>
            <ItemPrice
              currency={currency}
              subTotal={item.price.subTotal}
              tax={item.price.total - item.price.subTotal}
            />
          </P2GGrid>

          {slots?.['product-summary-header-suffix']?.(index, item.id, item)}
        </>
      )}
    </P2GGrid>
  );
}
